// src/components/PatientFileCard.jsx
import React, { useState } from "react";
import FileDropZone from "./FileDropZone";


const API = process.env.REACT_APP_API_URL;

export default function PatientFileCard({
  header = "Biographie",
  patientId,
  filePath,           // e.g. "patients/12/20240830_xyz.pdf" or null
  onChangeFilePath,   // cb(newPathOrNull)
}) {
  const [uploading, setUploading] = useState(false);
  const [removing, setRemoving] = useState(false);
  const [err, setErr] = useState("");
  async function handleUpload(file) {
    setErr("");
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const res = await fetch(`${API}/patients/${patientId}/file`, {
        method: "POST",
        credentials: "include",
        body: fd,
      });
      if (!res.ok) throw new Error(await res.text());
      const data = await res.json(); // { patient_id, bio_path }
      onChangeFilePath?.(data.bio_path || null);
    } catch (e) {
      setErr(e?.message || "Upload fehlgeschlagen.");
    } finally {
      setUploading(false);
    }
  }

  async function handleRemove() {
    if (!filePath) return;
    setErr("");
    setRemoving(true);
    try {
      const res = await fetch(`${API}/patients/${patientId}/file`, {
        method: "DELETE",
        credentials: "include",
      });
      if (!res.ok) throw new Error(await res.text());
      onChangeFilePath?.(null);
    } catch (e) {
      setErr(e?.message || "Löschen fehlgeschlagen.");
    } finally {
      setRemoving(false);
    }
  }

  const prettyName = filePath ? filePath.split("/").pop() : "";

  return (
    <section className="rounded-xl border border-blue-300 border-dashed bg-blue-50/40 p-4">
      <h2 className="text-base font-semibold text-gray-900 mb-2">{header}</h2>

      {err && (
        <div className="mb-3 rounded-md bg-red-50 border border-red-200 px-3 py-2 text-sm text-red-800">
          {err}
        </div>
      )}

    {filePath ? (
  // ✅ FILE EXISTS → show details, remove, download
  <div className="rounded-lg border border-blue-200 bg-white/70 p-4">
    <div className="flex items-start justify-between gap-3">
      <div className="flex items-center gap-3 min-w-0">
        <svg viewBox="0 0 24 24" className="h-9 w-9 text-black/80 shrink-0">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" fill="none" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M14 2v6h6" fill="none" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
        <span className="text-xl font-semibold text-gray-900 truncate">{prettyName}</span>
      </div>

      <button
        onClick={handleRemove}
        disabled={removing}
        className="text-blue-600 hover:underline text-sm shrink-0"
      >
        {removing ? "Entferne…" : "Anhang entfernen"}
      </button>
    </div>

    <hr className="my-3 border-blue-200/70" />

    <div className="flex justify-end">
      <a
        className="h-11 w-11 rounded-full bg-[#8EA2FF] hover:bg-[#7b8ef8] text-black/80 flex items-center justify-center shadow"
        href={`${API}/patients/${patientId}/file`}
        target="_blank"
        rel="noreferrer"
        title="Herunterladen"
      >
        <svg viewBox="0 0 24 24" className="h-6 w-6">
          <path d="M12 3v11m0 0l4-4m-4 4l-4-4" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M5 20h14" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
        </svg>
      </a>
    </div>
  </div>
) : (
  <FileDropZone
    onFile={handleUpload}
    onError={setErr}
    disabled={uploading}
    busyText="Biographie wird hochgeladen…"
    formats="PDF, PNG, JPG"
    className="flex flex-col items-center justify-center"
  />
)}
    </section>
  );
}
